export default __webpack_public_path__ + "static/media/logo-getinfo-1.c911b8e3.png";